var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"placement":"right","title":_vm.datas.noticetype,"width":870,"closable":true,"visible":_vm.visible,"mask-closable":false,"destroy-on-close":true,"wrap-class-name":"edit-notice-dia"},on:{"close":_vm.onClose}},[_c('item-edit',{attrs:{"item":_vm.cloneData,"hide":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }